import { config } from "../config";
import { callGateway, type CallerIdentity } from "./gateway";

/**
 * Door collection areas (owner 2026-11-02) -- radaccess
 * /access/operator/{ns}/areas and .../operatorlogins/{LoginID}/areas, RBAC
 * resource `area` (Owner and Admin write; Billing and Viewer read). An area is
 * disabled, never deleted. Paths are relative to gatewayBase (ends in /access).
 */
export interface Area {
  id: string;
  name: string;
  enabled: boolean;
  customers: number;
}

const at = (ns: string) => `/operator/${encodeURIComponent(ns)}`;

export async function listAreas(
  identity: CallerIdentity,
  ns: string,
  signal?: AbortSignal,
): Promise<Area[]> {
  return (
    await callGateway<Area[]>(
      identity,
      config().gatewayBase,
      `${at(ns)}/areas`,
      signal ? { signal } : {},
    )
  ).data;
}

export async function createArea(
  identity: CallerIdentity,
  ns: string,
  name: string,
): Promise<{ id: string; name: string }> {
  return (
    await callGateway<{ id: string; name: string }>(
      identity,
      config().gatewayBase,
      `${at(ns)}/areas`,
      { method: "POST", body: { name } },
    )
  ).data;
}

export async function collectorAreas(
  identity: CallerIdentity,
  ns: string,
  loginId: number,
  signal?: AbortSignal,
): Promise<string[]> {
  return (
    await callGateway<{ areas: string[] }>(
      identity,
      config().gatewayBase,
      `${at(ns)}/operatorlogins/${loginId}/areas`,
      signal ? { signal } : {},
    )
  ).data.areas;
}

export async function setCollectorAreas(
  identity: CallerIdentity,
  ns: string,
  loginId: number,
  areas: string[],
): Promise<void> {
  await callGateway<unknown>(
    identity,
    config().gatewayBase,
    `${at(ns)}/operatorlogins/${loginId}/areas`,
    { method: "PUT", body: { areas } },
  );
}

export const areaPaths = { at };
